module.exports = __webpack_public_path__ + "static/media/sidebar-13.23e05026.png";